/* eslint-disable no-nested-ternary */
import { Button, Link as LinkUI, Box } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import _ from 'lodash'

export default function DisplayConfigPriority({
  select,
  station,
  handleEditPriority,
}) {
  const params = useParams()

  const genGauge = () =>
    _.map(station?.gauges, (gauge, index) => {
      const checkRole = _.find(
        station?.priority,
        (pr) => pr?.role === params?.priority
      )
      const checkPriority = _.find(checkRole?.gauge, (e) => e === gauge?._id)
      return (
        <Box
          maxW="sm"
          borderWidth="1px"
          borderRadius="lg"
          bg={checkPriority ? 'blue.100' : ''}
          className=" ml-4 my-2 p-2 rounded w-full  md:w-full transition-transform transform   hover:scale-105"
          onClick={() => handleEditPriority(gauge)}
        >
          {gauge?.gaugeLabel}
        </Box>
      )
    })

  const genChart = () =>
    _.map(station?.charts, (chart, index) => {
      const checkRole = _.find(
        station?.priority,
        (pr) => pr?.role === params?.priority
      )
      const checkPriority = _.find(checkRole?.chart, (e) => e === chart?._id)
      return (
        <Box
          maxW="sm"
          borderWidth="1px"
          bg={checkPriority ? 'blue.100' : ''}
          className=" ml-4 my-2 p-2 rounded w-full  md:w-full transition-transform transform   hover:scale-105"
          onClick={() => handleEditPriority(chart)}
        >
          {chart?.chartLabel}
        </Box>
      )
    })
  const genDiagram = () =>
    _.map(station?.diagrams, (diagram, index) => {
      const checkRole = _.find(
        station?.priority,
        (pr) => pr?.role === params?.priority
      )
      const checkPriority = _.find(
        checkRole?.diagram,
        (e) => e === diagram?._id
      )
      return (
        <Box
          maxW="sm"
          borderWidth="1px"
          borderRadius="lg"
          bg={checkPriority ? 'blue.100' : ''}
          className=" ml-4 my-2 p-2 rounded w-full  md:w-full transition-transform transform   hover:scale-105"
          onClick={() => handleEditPriority(diagram)}
        >
          {diagram?.diagramName}
        </Box>
      )
    })

  if (station) {
    return (
      <div className="pl-4 pb-2">
        {select === 'GAUGE' ? (
          <div className="grid lg:grid-cols-6 sm:grid-cols-1 px-5">
            {genGauge()}
          </div>
        ) : select === 'CHART' ? (
          <div className="grid lg:grid-cols-6 sm:grid-cols-1 px-5">
            {genChart()}
          </div>
        ) : select === 'DIAGRAM' ? (
          <div className="grid lg:grid-cols-6 sm:grid-cols-1 px-5">
            {genDiagram()}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    )
  }
  return <div>404</div>
}
